import React, { Component, useState , useRef ,useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import Pagination from 'react-js-pagination';
import config from 'config';
import NoticeboardAPICall from 'NoticeboardAPICall';
import { FileDownloadOutlined, Close, EditOutlined, AttachFileOutlined, PrintOutlined } from "@mui/icons-material";
import ReactToPrint, { useReactToPrint } from 'react-to-print';
import '../PostNotice/NoticeApproval.css';
import { toast } from 'react-toastify';
import Spinner from 'NOTICEBOARD/CommonResources/SpinnerLoader/Spinner';
import NoticeView from '../Notices/NoticeView/NoticeView';
import ReactHtmlParser from 'react-html-parser';
import { Workspaces } from '@mui/icons-material';
import { saveAs } from "file-saver";



function NoticeApproval() {
    const componentRef = useRef(null);

    const [limit, setLimit] = useState(10);
    const [activePage, setActivePage] = useState(1);
    const [offset, setOffset] = useState(0);
    
    const [title, setTitle] = useState("");
    const [status, setStatus] = useState("");
    const [approvalList, setApprovalList] = useState([]);
    const [sortedIdArray, setSortedIdArray] = useState([]);
    const [fetchingApprovalList, setFetchingApprovalList] = useState(false);
    const [totalCount, setTotalCount] = useState("");
    const [selectedNoticeId, setSelectedNoticeId] = useState([]);
    const [showSideBarNoticeView, setShowSideBarNoticeView] = useState(false);
    const [fetchingIndividualNotice, setFetchingIndividualNotice] = useState(false);
    const [getIndividualNoticeDetails, setGetIndividualNoticeDetails] = useState({});
    const [noticeAttachments, setNoticeAttachments] = useState([]);
    const [allowedFileExtensions] = useState(['png', 'jpg', 'jpeg']);
    const [attachmentIndex, setAttachmentIndex] = useState(0);
    const [remark, setRemark] = useState("");
    const [remarkError, setRemarkError] = useState("");
    const [currentIndex, setCurrentIndex] = useState(0);
    const [selectedIndividualNoticeId, setSelectedIndividualNoticeId] = useState([]);
    const [clearButton, setClearButton] = useState(false);
    const [noticeId, setNoticeId] = useState("");
    const [hideCheckBoxColumn, setHideCheckBoxColumn] = useState(false);

    useEffect(() => {
        apiCallToGetAccessDetails();
    },[])
    useEffect(() => {
        apiCallToGetAccessDetails();
    },[limit , activePage])
    useEffect(() => {
        apiCallToGetIndividualNotice(sortedIdArray[currentIndex] || 0);
    },[currentIndex])
    
    useEffect(() => {
        if(clearButton)
        {
            apiCallToGetAccessDetails();
            setClearButton(false);
        }
    },[clearButton])

    // METHOD FOR GET NOTICE APPROVAL LIST
    const apiCallToGetAccessDetails = async () => {
        setFetchingApprovalList(true)
        let requestData = {
            institute_id: config.institute_id,
            user_id: config.faculty_id,
            limit:limit,
            pageIndex:activePage,
            filterByStatus : status,
            filterByTitle : title,
        };

        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            'getNoticeApprovalList',
            requestData,
            '/api/notice/notice.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToGetAccessDetails()
            }, 1000);
        } else {
            if (jsonResponse.success) 
            {
                let apiResult = jsonResponse.APIResult.data;
                setApprovalList(apiResult)
                setFetchingApprovalList(false);
                setTotalCount(jsonResponse.APIResult.totalCount);
                setSortedIdArray(jsonResponse.APIResult.sortedIdArray)
            } else 
            {
                setFetchingApprovalList(false);
                toast.error("Something went wrong while providing assign access. Please contact.")
            }
        }
    }
    // METHOD TO UPDATE NOTICE 
     const apiCallToGetUpdateNotice = async (status,type) => {
        let requestData = {
            institute_id: config.institute_id,
            user_id: config.faculty_id,
            uniqueIdArray : type == 'multiple' ? selectedNoticeId : [selectedIndividualNoticeId],
            status : status,
            remark : remark
        };

        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            'updateNoticeApproval',
            requestData,
            '/api/notice/notice.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToGetUpdateNotice()
            }, 1000);
        } else {
            if (jsonResponse.success) 
            {
                toast.success(jsonResponse.APIResult.message);
                apiCallToGetAccessDetails();
                setSelectedNoticeId([]);
            } else 
            {
                toast.error(jsonResponse.APIResult.message)
            }
        }
    }
    // METHOD FOR SET SHOW RESULT
    const setShowResult = (e) => {
        setLimit(e.target.value)
        setActivePage(1)
    }
    // METHOD FOR USER PAGINATION COUNT
    const updatePaginationCount = (pageNumber) => 
    {
        setOffset((pageNumber - 1) * limit)
        setActivePage(pageNumber);
        // setLimit(limit)
    }
    // HANDLE CLEAR BUTTON
    const handleClearBtn = () =>{
        setTitle("");
        setStatus("");
        setClearButton(true);
        setActivePage(1)
    }
    // METHOD FOR SAVE ATTACHMENT FILE 
    const saveFile = (attachment) => {
        saveAs(
            getIndividualNoticeDetails.attachmentPath + attachment,
            attachment
        );
    };

    // METHOD TO EXPORT REPORT
    useEffect(()=>{
        if(hideCheckBoxColumn)
        {
            document.getElementById('exportNoticeApprovalList').click();
            setHideCheckBoxColumn(false)
        }
    },[hideCheckBoxColumn])
    const exportNoticeApprovalList = () => {
        setHideCheckBoxColumn(true)
    }
    // HANDLE CHECKBOX
    const handlecheckBox = (e, type, uniqueId) => {
        if (type === 'all') 
        {
            if (e.target.checked) 
            {
                let temp = [];
                Object.values(approvalList)?.map((data)=>{
                   
                    temp.push(parseInt(data.uniqueid))
                })  
                // let temp = Object.keys(approvalList).map(id => parseInt(id));
                setSelectedNoticeId(temp);
            } else 
            {
                setSelectedNoticeId([]);
            }
        } else if (type === 'single') 
        {
            if (e.target.checked) 
            {
                setSelectedNoticeId(prevIds => [...prevIds, uniqueId]);
            } else 
            {
                setSelectedNoticeId(prevIds => prevIds.filter(id => id !== uniqueId));
            }
        }
    }
    // FUNCTION FOR GET INDIVIDUAL NOTICE DETAILS API CALL
    const apiCallToGetIndividualNotice = async (noticeId) => {
        setFetchingIndividualNotice(true);

        let formData = {
            institute_id: config.institute_id,
            notice_id: noticeId,
            user_id: config.faculty_id,
        };

        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            "getIndividualNoticeDetails",
            formData,
            '/api/notice/notice.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToGetIndividualNotice(noticeId);
            }, 1000);
        } else {
            if (jsonResponse.success) 
            {
                let apiResult = jsonResponse.APIResult.data;
                setSelectedIndividualNoticeId(noticeId);
                setFetchingIndividualNotice(false);
                setGetIndividualNoticeDetails(Object.values(apiResult)[0]);
                let noticeAttachments = Object.values(apiResult)[0].attachment != '' ? Object.values(apiResult)[0].attachment?.split(',') : [] ;
                setNoticeAttachments(noticeAttachments)
            } 
            else 
            {
                setFetchingIndividualNotice(false);
            }
        }
    }
    // VALIDATE UPDATE STATUS
    const validateNoticeStatus = (status) =>{
       let valid = true;
        if(remark.length == 0 )
        {
            setRemarkError('Please enter remark.')
            valid = false;
        }

        if(valid)
        {
            apiCallToGetUpdateNotice(status,'single');
            setRemarkError("")
        }

    }
    const handleCloseButton = () =>{
        setShowSideBarNoticeView(false) 
        setRemarkError("");
        setSelectedIndividualNoticeId("");
        setNoticeId("");

    }
    // MOVE TO NEXT OR PREVIOUS NOTICE
    const handleButtonClick = (direction) => 
    {
        let NoticeId = noticeId;
        let currentIndex = sortedIdArray.indexOf(NoticeId);
        
        if (currentIndex === -1) 
        {
            // Handle case where noticeId is not found in sortedIdArray
            return;
        }
        if (direction === 'right' && currentIndex < sortedIdArray?.length - 1) 
        {
            setCurrentIndex(currentIndex + 1);
            setNoticeId(sortedIdArray[currentIndex + 1]);
        } 
        else if (direction === 'left' && currentIndex > 0) 
        {
            setCurrentIndex(currentIndex - 1);
            setNoticeId(sortedIdArray[currentIndex - 1]);
        }
    };
    

    
    return (
        <div className="noticeApprover p-0">

            {/* FILTER DIV */}
            <div className='row col-md-12 mt-3 p-0'>
                <div className='col-md-3 mt-1' >
                    <input className='form-control' value={title} onChange={(e)=>{setTitle(e.target.value)}} style={{fontSize:'11px'}} placeholder='Search by notice name' />
                </div>
                <div className='col-md-3 mt-1' >
                    <select className='form-control' style={{fontSize:'11px'}} value={status} onChange={(e)=>{setStatus(e.target.value)}} >
                        <option value="" >Select notice status</option>
                        <option value="Pending" >Drafted</option>
                        <option value="Approved" >Approved</option>
                        <option value="Declined" >Declined</option>
                    </select>
                </div>

                <div className='d-flex col-md-3' >
                    <div>
                        <button className='btn btn-outline-primary applyBtn' onClick={()=>{setActivePage(1); apiCallToGetAccessDetails() }} >Apply</button>
                    </div>
                    <div>
                        <button className='clearBtn btn btn-primary' onClick={()=>{handleClearBtn()}} >Clear</button>
                    </div>
                </div>
            </div>

            {/* SHOW ENTRIES */}
            <div className='justify-content-between d-flex' >   
                <div className='addCategories ml-3 mt-3 d-flex justify-content-start'>
                    <div className='showResult'>Show entries</div>
                    <select
                        className="form-select"
                        aria-label="Default select example"
                        value={limit}
                        onChange={(e) => setShowResult(e)}
                        style={{ fontSize: 12, marginRight: 10 }}
                    >
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="40">40</option>
                        <option value="100">100</option>
                        <option value="250">250</option>
                    </select>
                </div>

                <div className="export-values" style={{ paddingRight: 0 }}>
                    <div>
                        <ReactToPrint
                            trigger={() =>
                                <button className="btn btn-outline-blue applyBtn">
                                    <FontAwesomeIcon className='mr-2' icon={['fas', 'print']} size="sm" />
                                    Print
                                </button>
                            }
                            content={() => componentRef.current} // Pass the ref as the content
                        />
                    </div>
                    <div style={{ display: 'none' }}>
                        <ReactHTMLTableToExcel
                            id="exportNoticeApprovalList"
                            className="download-table-xls-button btn btn-success mb-3"
                            table="noticeApproval"
                            filename="Notice Approval List"
                            sheet="tablexls"
                            buttonText="Export"
                        />
                    </div>
                    <button className='btn btn-primary clearBtn' onClick={() => exportNoticeApprovalList()} >
                        <FontAwesomeIcon icon={['fas', 'file-export']} style={{ marginRight: 4 }} />
                        Export
                    </button>
                </div>
            </div>

            <div className='ml-3 mt-4 table-responsive' ref={componentRef} >
                <table id='noticeApproval' className='table table-bordered '>
                    <thead>
                     <tr>
                        {
                            !hideCheckBoxColumn &&
                            <td style={{padding:'5px', display : hideCheckBoxColumn ? 'none' : "" }} className='HidePrint' >
                                <input type="checkbox" 
                                onChange={(e)=>{handlecheckBox(e,"all")}} 
                                />
                            </td>
                        }
                        <td style={{padding:'5px',fontWeight:'bold'}}> Sr. No.</td>  
                        <td style={{padding:'5px',fontWeight:'bold'}}> Notice Title</td>
                        <th style={{padding:'5px',fontWeight:'bold'}}> Notice Id</th>
                        <th style={{padding:'5px',fontWeight:'bold'}}> Category</th>
                        <td style={{padding:'5px',fontWeight:'bold'}}> Posted On</td>
                        <td style={{padding:'5px',fontWeight:'bold'}}> Notice Date</td>
                        <td style={{padding:'5px',fontWeight:'bold'}}> Status </td>
                        <td style={{padding:'5px',fontWeight:'bold'}}> Remark </td>
                        <td style={{padding:'5px',fontWeight:'bold'}}> Posted By</td>
                        <td style={{padding:'5px',fontWeight:'bold'}}> Approved By</td>
                        <td style={{padding:'5px',fontWeight:'bold'}}> Approved On</td>
                     </tr>
                     {
                        selectedNoticeId?.length > 0 &&
                        <tr>
                            <td colSpan={10} className='table-primary p-0' >
                                <button className='btn rounded-pill btn-primary p-1 px-3 ml-5' style={{fontSize:'12px !important'}} onClick={() =>{apiCallToGetUpdateNotice('Approved','multiple')}} >Approve</button>
                                <button className='btn rounded-pill btn-primary p-1 px-3 ' style={{fontSize:'12px !important'}} onClick={() =>{apiCallToGetUpdateNotice('Declined','multiple')}} >Decline</button>
                            </td>
                        </tr>
                     }
                    </thead>
                    <tbody >
                        {
                            fetchingApprovalList ?
                                <Spinner />
                                :
                                sortedIdArray?.length > 0 ?
                                  sortedIdArray?.map((uniqueId, index) => {
                                    let data = approvalList?.[uniqueId];
                                    if(data) 
                                    {
                                        return (
                                                <tr key={index}>
                                                {
                                                    !hideCheckBoxColumn &&
                                                    <td style={{ padding: '5px', display: hideCheckBoxColumn ? 'none' : "" }} className='HidePrint' >
                                                        <input type="checkbox"
                                                            checked={Array.isArray(selectedNoticeId) && selectedNoticeId?.includes(uniqueId)}
                                                            onChange={(e) => { handlecheckBox(e, "single", uniqueId) }}
                                                        // disabled = {data.status === "Approved"}
                                                        />
                                                    </td>
                                                }
                                                <td style={{padding:'5px'}} >{((activePage - 1) * limit) + index + 1}</td>
                                                <td className='primaryColor capitalizeWord text-truncate pointer'style={{padding:'5px'}} title={data.title} onClick={ () => { setShowSideBarNoticeView(true); apiCallToGetIndividualNotice(uniqueId) ;setNoticeId(uniqueId) }} >{ data.title.length > 50 ? data.title.substring(0,25) + "..." : data.title }</td>
                                                <td style={{padding:'5px'}} >{data.categorySeries?.length > 0 && `${data.categorySeries}-${data.categoryNumber}`}</td>
                                                <td style={{padding:'5px'}} >{data.notice_category_name}</td>
                                                <td style={{padding:'5px'}} >{data.addedon}</td>
                                                <td style={{padding:'5px'}} >{data.noticeDateTime}</td>
                                                <td style={{ padding: '5px' }}>
                                                {
                                                    data.status === "Pending" ? 
                                                    (
                                                        <span className='approved px-2' style={{ backgroundColor: '#fc7800' }}>{data.status}</span>
                                                    ) 
                                                       : 
                                                    (
                                                        data.status === "Approved" ? 
                                                        (
                                                            <span className='approved px-2' style={{ backgroundColor: '#219653' }}>{data.status}</span>
                                                        ) 
                                                        : 
                                                        (
                                                            <span className='approved px-2' style={{ backgroundColor: '#AA1E1E' }}>{data.status}</span>
                                                        )
                                                    )
                                                }
                                                </td>
                                                <td style={{ padding: '5px', maxWidth: '150px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={data.remark}> {data.remark} </td>
                                                <td style={{padding:'5px'}} >{data.facultyName}</td>
                                                <td style={{padding:'5px'}} >{data.approvedFacultyName}</td>
                                                <td style={{padding:'5px'}} >{data.approvedon}</td>
                                            </tr>   
                                        )
                                    }
                                    })
                                    :
                                    <tr>
                                        <td colSpan={12} > No notices found as per applied filter. </td>
                                    </tr>
                        }

                    </tbody>
                </table>

                   {/* PAGINATION FOR USER MANAGEMENT LIST */ }
                {
                     sortedIdArray?.length > 0 &&
                    <div className="paginationContainer HidePrint">
                        <Pagination
                            activePage={ activePage }
                            itemsCountPerPage={ limit }
                            totalItemsCount={ totalCount }
                            pageRangeDisplayed={ 3 }
                            onChange={ (num) => updatePaginationCount(num) }
                        />
                    </div>
                }
            </div>  
            <br/><br/>
            {
                    showSideBarNoticeView &&
                <>
                    <div id="sideBar">
                        <div id="sideBarContainer">
                            <div className="sideBarHeader d-flex justify-content-center align-items-center">
                                <div style={{ cursor: "pointer" }}>
                                    <Close className="mx-2" onClick={() => handleCloseButton() } />
                                </div>
                                <div className="p-1 flex-grow-1 text-center">
                                    <p>Notice View</p>
                                </div>
                            </div>
                             {
                                fetchingIndividualNotice ?
                                    <Spinner />   
                                    : 
                                <div className='mt-4' >
                                    <div className='col-md-12 justify-content-between d-flex mb-2' >
                                       <FontAwesomeIcon className='primary-ic' style={{cursor:'pointer'}} icon={['fas', 'chevron-circle-left']} onClick={() => handleButtonClick('left')} disabled={currentIndex == 0} />
                                        <div className='d-flex' >
                                            <div>
                                                <input onChange={(e)=>{setRemark(e.target.value);setRemarkError("")}} className='form-control mt-1' style={{fontSize:'11px'}} placeholder='Enter remark here.' />
                                                <small style={{color:'red'}} >{remarkError}</small>
                                            </div>
                                            <div className='d-flex mb-1'>
                                                <button className='btn btn-primary applyBtn'onClick={() =>{validateNoticeStatus('Approved')}} >Approve</button>
                                                <button className='btn btn-primary-outline applyBtn' onClick={() =>{validateNoticeStatus('Declined')}} >Decline</button>
                                            </div>
                                        </div>
                                       <FontAwesomeIcon className='primary-ic' style={{cursor:'pointer'}} icon={['fas', 'chevron-circle-right']} onClick={() => handleButtonClick('right')} disabled={currentIndex == sortedIdArray.length - 1} />

                                    </div>
                                    <div className="row p-0">
                                        <div className="col-12 smallFont">
                                            <div className="row">
                                                <div className="my-1 px-0 col-md-11 col-sm-12">
                                                    <h6 style={{ fontWeight: "bold", color: "black" }}>
                                                        {
                                                            (getIndividualNoticeDetails && getIndividualNoticeDetails.title) &&
                                                            getIndividualNoticeDetails.title
                                                        }
                                                    </h6>
                                                    <div className="d-flex justify-content-between">
                                                        <p>By {(getIndividualNoticeDetails && getIndividualNoticeDetails.addedBy) && getIndividualNoticeDetails.addedBy}</p>
                                                        <p className="secondaryColor">{(getIndividualNoticeDetails && getIndividualNoticeDetails.formattedNoticeDate) && getIndividualNoticeDetails.formattedNoticeDate}</p>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <div className='flex pl-2' style={{ whiteSpace: 'normal', wordBreak: 'break-all' }}>
                                            <Workspaces style={{ fontSize: '16px', color: '#BDBDBD', marginRight: '10px' }} />
                                            {
                                                (getIndividualNoticeDetails && getIndividualNoticeDetails.categoryName) && getIndividualNoticeDetails.categoryName
                                            }
                                        </div>
                                        <div className=''>
                                            {
                                                (getIndividualNoticeDetails && getIndividualNoticeDetails.department) &&
                                                <div className="my-1 smallFont col-12 d-flex" style={{ gap: '15px', marginTop: 10 }}>
                                                    {
                                                        getIndividualNoticeDetails.department.split(',').map(department => {
                                                            return <li>{department}</li>;
                                                        })
                                                    }
                                                </div>
                                            }
                                        </div>
                                        <div className="col-12" style={{ marginTop: 10 }}>
                                            <p className="smallFont" style={{ wordSpacing: "5px", textAlign: 'justify' }}>

                                                {
                                                    (getIndividualNoticeDetails && getIndividualNoticeDetails.description) &&
                                                    ReactHtmlParser(getIndividualNoticeDetails.description)
                                                }
                                            </p>
                                        </div>
                                        {
                                             noticeAttachments && noticeAttachments.length > 0 &&
                                            <div className="col-12 attachment-view-details" style={{ marginTop: 10 }}>
                                                <div className="row attachment-list" style={{ gap: "20px" }}>
                                                    {
                                                        noticeAttachments.map((attachment, noticeAttachmentIndex) => {
                                                            return (
                                                                <>
                                                                    {
                                                                        allowedFileExtensions.includes(attachment.substring(attachment.lastIndexOf('.') + 1)) ?
                                                                            <div className="book d-flex justify-content-center align-items-center flex-column" style={{ backgroundImage: `url(${getIndividualNoticeDetails.attachmentPath + attachment})`, border: noticeAttachmentIndex == attachmentIndex ? '2px solid #0465AC' : 'none' }} onClick={() => setAttachmentIndex(noticeAttachmentIndex)}>
                                                                                <div className="flex-grow-1"></div>
                                                                                <div className="bookDownloadSection hideWhenPrint">
                                                                                    <FileDownloadOutlined className="downloadButton  pointer" onClick={() => saveFile(attachment)} />
                                                                                </div>
                                                                            </div>
                                                                            :
                                                                            <div className="pdfBook d-flex flex-column" style={{ border: noticeAttachmentIndex == attachmentIndex ? '2px solid #0465AC' : 'none' }} onClick={() => setAttachmentIndex(noticeAttachmentIndex)}>
                                                                                <FontAwesomeIcon className="pdfIcon" icon={['fas', 'file-pdf']} />
                                                                                <div className="bookDownloadSection hideWhenPrint">
                                                                                    <FileDownloadOutlined onClick={() => saveFile(attachment)} className="downloadButton  pointer" />
                                                                                </div>
                                                                            </div>
                                                                    }
                                                                </>
                                                            );
                                                        })
                                                    }
                                                </div>
                                                {
                                                    noticeAttachments && noticeAttachments.length > 0 &&
                                                    <div className="attachment-preview hideWhenPrint">
                                                        {
                                                            allowedFileExtensions.includes(noticeAttachments[attachmentIndex].substring(noticeAttachments[attachmentIndex].lastIndexOf('.') + 1)) ?
                                                                <img src={getIndividualNoticeDetails.attachmentPath + noticeAttachments[attachmentIndex]} width="100%" height='100%' />
                                                                :
                                                                <iframe src={getIndividualNoticeDetails.attachmentPath + noticeAttachments[attachmentIndex]} width="100%" height='100%' />
                                                        }
                                                    </div>
                                                }
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </>
            }

        </div>
    )
}

export default NoticeApproval

